export const COLOR_ITEM_CLASSNAME = 'wui-color-picker-item';

export const COLOR_AREA_CANVAS_WIDTH_PX = 250;
export const COLOR_AREA_CANVAS_HEIGHT_PX = 150;
export const COLOR_PICKER_POPOVER_MAX_WIDTH_PX = 278;

export const SV_AREA_CANVAS_WIDTH_PX = COLOR_AREA_CANVAS_WIDTH_PX;
export const SV_AREA_CANVAS_HEIGHT_PX = COLOR_AREA_CANVAS_HEIGHT_PX;

export const THREE_SIXTY = 360;
export const TWO_FIFTY_FIVE = 255;

export const DEFAULT_MIN_CONTRAST = 4.5;
export const DEFAULT_COLOR_FOR_COMPARISON = '#ffffff';
export const DEFAULT_OPACITY_FOR_CONTRAST_CALCULATION = 1;

export const DEFAULT_SWATCH_DIAMETER_PX = 24;
